module.exports = __webpack_public_path__ + "img/benefits-students-2.ee5c6cd0.svg";